import { Check, Users, Heart, Shield, Stethoscope, Sparkles } from "lucide-react";
import { motion } from "framer-motion";

const reasons = [
  {
    icon: Stethoscope,
    title: "MDS Specialists",
    description: "Multispeciality dental clinic with top-qualified consultants",
  },
  {
    icon: Heart,
    title: "Patient-First Care",
    description: "Ethical dentistry — no unnecessary procedures, ever",
  },
  {
    icon: Sparkles,
    title: "Advanced Technology",
    description: "Painless, faster & safer treatments with modern equipment",
  },
  {
    icon: Shield,
    title: "Safety Protocols",
    description: "Strict sterilization and hospital-grade hygiene standards",
  },
  {
    icon: Check,
    title: "Transparent Pricing",
    description: "Clear treatment plans with no hidden costs",
  },
  {
    icon: Users,
    title: "Family Environment",
    description: "Friendly, caring atmosphere for all age groups",
  },
];

export const WhyChooseUs = () => {
  return (
    <section id="why-us" className="py-20 bg-secondary/50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="inline-block bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium mb-4">
            Why Families Trust Us
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            The Smile Care Difference
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            "We treat patients like family — not cases."
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, index) => (
            <motion.div
              key={reason.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="group bg-card rounded-2xl p-6 shadow-soft hover:shadow-card transition-all duration-300 border border-border/50"
            >
              <div className="w-14 h-14 rounded-xl gradient-primary flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <reason.icon className="w-7 h-7 text-primary-foreground" />
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-2">
                {reason.title}
              </h3>
              <p className="text-muted-foreground">{reason.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
